var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFblogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#ffffff",
      strokeWidth: 0,
      strokeDasharray: "#ffffff",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#ffffff",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 56 2 c 4.227 0 8.057 0.232 10.345 0.432 v 10.509 l -6.424 0.003 c -8.804 0 -9.933 5.234 -9.933 9.793 v 10.22 v 2 h 2 h 13.615 L 64.05 47.004 H 51.988 h -2 v 2 V 88 H 37.424 V 49.004 v -2 h -2 H 23.655 V 34.957 h 11.769 h 2 v -2 V 21.148 C 37.424 9.158 44.368 2 56 2 M 56 0 C 43.786 0 35.424 7.456 35.424 21.148 v 11.809 H 21.655 v 16.046 h 13.769 V 90 h 16.564 V 49.004 h 13.821 l 2.069 -16.046 h -15.89 v -10.22 c 0 -4.635 1.287 -7.793 7.933 -7.793 l 8.424 -0.004 V 0.63 C 66.879 0.436 61.851 0 56 0 L 56 0 z",
    style: {
      stroke: "#ffffff",
      strokeWidth: 1,
      strokeDasharray: "#ffffff",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#ffffff",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFblogo);
export default __webpack_public_path__ + "static/media/fblogo.e86bccafbddb94c4f9ecf46f1ef2dc12.svg";
export { ForwardRef as ReactComponent };